const TEIFI_LOGIN_CLASS = '.teifi-login';
const EMAIL_FIELD_ID = 'CustomerEmail';
const REGION_SELECT_ID = 'select-region';
let fetching = false;

(function () {
  const params = new URLSearchParams(window.location.search);
  const email = params.get('email');
  if (email != null) {
    document.getElementById(EMAIL_FIELD_ID).value = email;
  }
})();



document.querySelectorAll(TEIFI_LOGIN_CLASS).forEach(e => e.addEventListener("click", async function (event) {
  e.disabled = true;
  event.preventDefault();
  event.stopImmediatePropagation();

  const email = document.getElementById(EMAIL_FIELD_ID)?.value?.toLowerCase()?.trim();


  let shops = [];
  try {
    shops = await fetchShops(email);
  } catch(err) {
    console.error(err);
    showError('An error occured, try again later!');
    e.disabled = false
    fetching = false
    return
  }
  fetching = false;
  const selectDiv = document.getElementById(REGION_SELECT_ID);
  const select = selectDiv.querySelector('select');

  const hidden = selectDiv.style.display === 'none';

  // If hidden and only one shop, redirect to that shop
  // If hidden and multiple shops, show select
  // If visible, get selected value and redirect to that shop
  if (hidden) {
    if(shops.length <= 1){
      const shop = shops.find(Boolean);
      if (shop == null) {
        showError('No store found');
        e.disabled = false
        fetching = false
        return;
      }

      const params = new URLSearchParams({ email, return_to: '/' })
      const redirectUrl = `https://${shop}/pages/login?${params}`;
      console.log(`Redirecting to '${redirectUrl}'`);
      window.location.href = redirectUrl;
      return;
    }
    selectDiv.style.display = 'block';
    for (const shop of shops) {
      const option = document.createElement('option');
      option.value = shop;
      option.text = shop;
      select.appendChild(option);
    }
    select.value = shops[0];
    e.disabled = false;
  }else{
    const shop = select.value;
    if (shop == null) {
      showError('No store found');
      e.disabled = false
      fetching = false
      return;
    }
    const params = new URLSearchParams({ email, return_to: '/' })
    const redirectUrl = `https://${shop}/pages/login?${params}`;
    console.log(`Redirecting to '${redirectUrl}'`);
    window.location.href = redirectUrl;
  }
}));


document.getElementById(EMAIL_FIELD_ID)?.addEventListener("input", async function (event) {
  document.getElementById(REGION_SELECT_ID).style.display = 'none';
});



function showError(msg) {
  alert(msg);
}

async function fetchShops(email) {
  if (fetching) return;
  fetching = true;

  const q = new URLSearchParams({ email });
  const data = await fetch(`/apps/mbt-integrations/api/customers/shops?${q}`);
  const text = await data.text();

  let body;
  try {
    body = JSON.parse(text);
  } catch (e) {
    throw new Error(`Unable to parse JSON '${text}'`);
  }

  const shops = body?.shops;
  if (!Array.isArray(shops)) {
    throw new Error(`Unexpected response: '${text}'`)
  }

  return shops;
}
